import { MutableRefObject, useRef, useState } from 'react';

export interface AutocompleteParams {
  countries?: string[];
  inputRef: MutableRefObject<HTMLInputElement | undefined>;
  onPlaceChanged?: (place?: google.maps.places.PlaceResult) => void;
}

export interface AutocompleteResponse {
  ready: boolean;
  init: (params: AutocompleteParams) => void;
  setComponentRestrictions: (restrictions: google.maps.places.ComponentRestrictions | null) => void;
}

const useGooglePlacesAutocomplete = (): AutocompleteResponse => {
  const autocomplete = useRef<google.maps.places.Autocomplete>();
  const [initialized, setInitialized] = useState<boolean>(false);

  const init = ({ countries, inputRef, onPlaceChanged }: AutocompleteParams): void => {
    autocomplete.current = undefined;
    if (!!inputRef.current) {
      autocomplete.current = new google.maps.places.Autocomplete(inputRef.current, {
        componentRestrictions: { country: countries || ['us'] },
        fields: ['address_components', 'formatted_address', 'geometry.location', 'place_id', 'name']
      });

      autocomplete.current.addListener('place_changed', () => {
        const place = autocomplete.current?.getPlace();
        !!onPlaceChanged && onPlaceChanged(place);
      });
      setInitialized(true);
    }
  };

  const setComponentRestrictions = (
    restrictions: google.maps.places.ComponentRestrictions | null
  ): void => {
    if (!autocomplete.current) return;

    autocomplete.current.setComponentRestrictions(restrictions);
  };

  return { ready: initialized, init, setComponentRestrictions };
};

export default useGooglePlacesAutocomplete;
